
/**
 * 트윗 유형
 */
export type TweetListResponsePageAllOfThreeContentItemBasicInfoAllOfTwoTweetType = typeof TweetListResponsePageAllOfThreeContentItemBasicInfoAllOfTwoTweetType[keyof typeof TweetListResponsePageAllOfThreeContentItemBasicInfoAllOfTwoTweetType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TweetListResponsePageAllOfThreeContentItemBasicInfoAllOfTwoTweetType = {
  ORIGINAL: 'ORIGINAL',
  REPLY: 'REPLY',
  QUOTE: 'QUOTE',
  RETWEET: 'RETWEET',
} as const;
